import React from "react";
import styles from "./Modal.module.scss";

export const ModalFooter: React.FC = ({ children }) => {
  return <footer className={styles["footer"]}>{children}</footer>;
};
